import { consoleError } from './app/utils';

import { ROLES } from 'constants/roles';

const DBName = 'ectNMMAdb';

export default class Store {
  constructor(dbVersion) {
    openDB(dbVersion);
  }

  static insert = (store, insartion, code) => {
    return openDB()
      .then(db => {
        return new Promise((resolve, reject) => {
          const transaction = getTransaction(db, store);
          const storeObject = getStoreObject(transaction, store);

          if (insartion.length === undefined) {
            if (code) insartion.primaryAccount = code;
            storeObject.put(insartion);
          } else {
            insartion.forEach(value => {
              if (code) value.primaryAccount = code;
              storeObject.put(value);
            });

            storeObject.openCursor().onsuccess = function({target}) {
              var cursor = target.result;
              if (cursor) {
                if (code && +code === +cursor.value.primaryAccount) {
                  if (!insartion.find(ins => ((ins.id && +ins.id === +cursor.value.id) ||
                    (ins.code && +ins.code === +cursor.value.code)))) {
                    cursor.delete();
                  }
                } else if (!code) {
                  if (!insartion.find(ins => +ins.code === +cursor.value.code)) {
                    cursor.delete();
                  }
                }

                cursor.continue();
              }
            };
          }

          transaction.oncomplete = ({target}) => {
            resolve(target.result);
          };

          transaction.onerror = ({target}) => {
            reject(target);
          };
        });
      });
  };

  static delete = (store, itemToDelete) => {
    return openDB()
      .then(db => {
        return new Promise((resolve, reject) => {
          const transaction = getTransaction(db, store);
          const storeObject = getStoreObject(transaction, store);
          storeObject.delete(itemToDelete.id || itemToDelete.code);

          transaction.oncomplete = ({target}) => {
            resolve(target.result);
          };

          transaction.onerror = ({target}) => {
            reject(target);
          };
        });
      });
  };

  static select = (store, key) => {
    return openDB()
      .then(db => {
        return new Promise((resolve, reject) => {
          const transaction = getTransaction(db, store);
          const storeObject = getStoreObject(transaction, store);
          const resultArray = [];

          const map = key
            ? storeObject.index('primaryAccount').openCursor(IDBKeyRange.only(key.toString()))
            : storeObject.openCursor();

          map.onsuccess = ({target}) => {
            const cursor = target.result;
            if (cursor) {
              resultArray.push(cursor.value);
              cursor.continue();
            }
          };

          transaction.oncomplete = () => {
            resolve(resultArray);
          };

          transaction.onerror = ({target}) => {
            reject(target);
          };
        });
      });
  };
}

function openDB(DBVersion) {
  return new Promise((resolve, reject) => {
    const params = [DBName];
    if (DBVersion) params.push(DBVersion);

    const dbRequest = indexedDB.open(...params);

    dbRequest.onupgradeneeded = ({target}) => {
      const db = target.result;

      Object.keys(ROLES).forEach(role => {
        try {
          db.deleteObjectStore(ROLES[role].serverName);
        } catch (e) {
          consoleError(e);
        }

        try {
          const manufacturers = db.createObjectStore(ROLES[role].serverName, {keyPath: 'dbKey'});
          manufacturers.createIndex('primaryAccount', 'primaryAccount', {unique: false});
        } catch (e) {
          consoleError(e);
        }

        try {
          db.deleteObjectStore(`${ROLES[role].serverName}_inspectors`);
        } catch (e) {
          consoleError(e);
        }

        try {
          const inspectors = db.createObjectStore(`${ROLES[role].serverName}_inspectors`, {keyPath: 'code'});
          inspectors.createIndex('code', 'code', {unique: false});
        } catch (e) {
          consoleError(e);
        }

        try {
          db.deleteObjectStore(`${ROLES[role].serverName}_documents`);
        } catch (e) {
          consoleError(e);
        }

        try {
          const manufacturers = db.createObjectStore(`${ROLES[role].serverName}_documents`, {keyPath: 'id'});
          manufacturers.createIndex('primaryAccount', 'primaryAccount', {unique: false});
        } catch (e) {
          consoleError(e);
        }

        try {
          if (ROLES[role].serverName === 'INSPEC') {
            db.deleteObjectStore(`INSPEC_${ROLES.BOAT_MANUFACTURER.serverName}_LISTS`);
            db.deleteObjectStore(`INSPEC_${ROLES.TRAILER_MANUFACTURER.serverName}_LISTS`);
          } else {
            db.deleteObjectStore(`${ROLES[role].serverName}_lists`);
          }
        } catch (e) {
          consoleError(e);
        }

        try {
          if (ROLES[role].serverName === 'INSPEC') {
            const boat = db.createObjectStore(`INSPEC_${ROLES.BOAT_MANUFACTURER.serverName}_LISTS`, {keyPath: 'id'});
            boat.createIndex('primaryAccount', 'primaryAccount', {unique: false});

            const trailer = db.createObjectStore(`INSPEC_${ROLES.TRAILER_MANUFACTURER.serverName}_LISTS`, {keyPath: 'id'});
            trailer.createIndex('primaryAccount', 'primaryAccount', {unique: false});
          } else {
            const obj = db.createObjectStore(`${ROLES[role].serverName}_lists`, {keyPath: 'id'});
            obj.createIndex('primaryAccount', 'primaryAccount', {unique: false});
          }
        } catch (e) {
          consoleError(e);
        }
      });

      try {
        db.deleteObjectStore(`${ROLES.COMPONENT_MANUFACTURER.serverName}_families_lists`);
      } catch (e) {
        consoleError(e);
      }

      try {
        const obj = db.createObjectStore(`${ROLES.COMPONENT_MANUFACTURER.serverName}_families_lists`, {keyPath: 'id'});
        obj.createIndex('primaryAccount', 'primaryAccount', {unique: false});
      } catch (e) {
        consoleError(e);
      }
    };

    dbRequest.onsuccess = ({target}) => {
      const db = target.result;

      db.onerror = errorHandler;

      resolve(db);
    };
    dbRequest.onerror = ({target}) => reject(target);
  });
}

function getTransaction(db, store) {
  return db.transaction([store], 'readwrite');
}

function getStoreObject(transaction, store) {
  return transaction.objectStore(store);
}

function errorHandler(error) {
  if (process.env.NODE_ENV === 'development') {
    consoleError(error);
  } else {
    consoleError('You have a problems with local database connection.');
  }
}



// WEBPACK FOOTER //
// ./src/registerIDBWorker.js